<template>
    <div class="greybox">
        <h1>Available repair options</h1>
        <span v-if="selectedClaim && selectedClaim.status !== 'APPROVED'">Your claim has not been approved!<br /></span>
        <div v-else>
          <span v-if="isLoading">Loading...</span>
          <div v-else>
            <options-list v-if="repairOptionsList && repairOptionsList.length > 1" @selected="optionSelected" />
            <div v-if="!repairOptionsList">
              <div v-if="retryCount < 3">
                It looks like something went wrong getting the repair options for you.<br/>
                <button class="button-small mt-3 mb-3" @click="handleTryAgainClick()"><i class="fas fa-redo-alt"></i> Try again</button>
              </div>
              <div v-else>
                We are unable to display repair options for you at the moment.  Please try again later or contact us on the number above.
              </div>
            </div>
          </div>
        </div>
        <button class="button mt-3" @click="handleBackToClaim()">Back to Claim details</button>

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>
<script>
import loading from 'vue-loading-overlay'
import { mapActions } from 'vuex'
import optionsList from '@/components/RepairOptionsList.v2.vue'
import repairOptionsBase from '@/mixins/repairOptionsBase'

const DEFAULT_PATH = '/'

export default {
  components: {
    optionsList,
    loading
  },
  mixins: [
    repairOptionsBase
  ],
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // check for login and keep default...
      let { path } = from
     
      if (path != '/login') {
        vm.referer = path
      }
    })
  },
  async beforeMount () {
    await this.loadOptions(this.selectedGadgetId)
    this.loadSelectedClaim(this.selectedGadgetId)
    if(this.$store.state.repairoptions.repairOptionsList.length === 1) {     
      this.selectedRepairOption = this.$store.state.repairoptions.repairOptionsList[0]
      this.$router.push({ path: '/myclaims/repairoptions/info/' })
    }     
  },
  data () {
    return {
      referer: DEFAULT_PATH,
      retryCount: 0
    }
  },
  methods: {
    optionSelected (option) {
      this.selectedRepairOption = option
      this.$router.push({ path: '/myclaims/repairoptions/info/' })
    },
    handleCloseClick () {
      this.$router.push({ path: this.referer })
    },
    handleBackToClaim () {
      this.$router.push({ path: '/myclaims/view/' + this.selectedClaim.id })
    },
    handleTryAgainClick() {
      this.retryCount = this.retryCount + 1

      this.loadOptions(this.selectedGadgetId)
    }
  }
}
</script>
